var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comment_list"},[_c('div',{staticClass:"comment_title"},[_vm._v(" "+_vm._s(_vm.$t('CommentTitle'))+" ")]),_c('div',{staticClass:"comment_content"},[_c('loading-image',{attrs:{"imageUrl":`${_vm.$store.state.assetsUrl}/imgs/plan/comment.webp`,"min-height":'300px'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }